/* @generated */

// src/assets/ui-icon/line/customize.tsx
import * as React from "react";
var CustomizeLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12.82 9.178a.89.89 0 0 1 .993-.993.89.89 0 0 1 .993.993.89.89 0 0 1-.993.993.89.89 0 0 1-.993-.993Zm-3.532 0a.89.89 0 0 1 .994-.993.89.89 0 0 1 .993.993.89.89 0 0 1-.993.993.89.89 0 0 1-.994-.993Zm0 5.14a.89.89 0 0 1 .994-.993.89.89 0 0 1 .993.993.89.89 0 0 1-.993.994.89.89 0 0 1-.994-.994ZM6.82 11.975a.89.89 0 0 1 .993-.993.89.89 0 0 1 .993.993.89.89 0 0 1-.993.993.89.89 0 0 1-.993-.993Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.515 5.314c3.597-.258 7.646 1.372 8.447 5.413.208 1.05-.077 2.139-.885 2.73-.87.635-2.013.473-3.028-.342l-.03-.024-.028-.028a.997.997 0 0 0-.703-.3h-.028l-.028-.002a.702.702 0 0 0-.488.155.891.891 0 0 0-.31.51.984.984 0 0 0 .07.632c.091.19.237.328.4.4l.026.012.026.014c.824.447 1.22 1.38 1.078 2.243-.154.93-.896 1.684-2.097 1.873-2.26.356-4.732-.151-6.643-1.286-1.91-1.134-3.371-2.976-3.318-5.318v-.013c.175-4.213 3.935-6.41 7.54-6.669Zm-6.04 6.724c-.033 1.62.97 3.027 2.585 3.986 1.618.961 3.738 1.394 5.643 1.094.646-.101.816-.422.85-.635a.662.662 0 0 0-.294-.67 2.32 2.32 0 0 1-1.108-1.108 2.482 2.482 0 0 1-.183-1.6 2.39 2.39 0 0 1 .847-1.366 2.202 2.202 0 0 1 1.5-.475c.636.007 1.24.262 1.7.703.662.52 1.033.383 1.177.279.207-.152.428-.573.298-1.227-.589-2.972-3.638-4.44-6.867-4.209-3.22.231-6.014 2.108-6.147 5.228Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CustomizeLine
};
